import React, {Component} from 'react'
import qs from "qs";
import { withRouter } from 'react-router-dom'
import {deepRemoveBlanks} from 'utils'
import {IndexContext} from 'components'

export default Type => withRouter(class Search extends Component {

  serializeUrlState = (state) => {
    let qsObject = deepRemoveBlanks(state.filter) || {}
    if (state.page !== defaultPage)
      qsObject.page = state.page
    if (state.order)
      qsObject.order = state.order
    return qs.stringify(qsObject, {arrayFormat: 'repeat', allowDots: true})
  }

  updateUrlState = (state) => {
    this.props.history.replace(window.location.pathname + '?' + this.serializeUrlState(state))
    this.forceUpdate()
  }

  get urlState() {
    if (window.location.search) {
      const {page, order, ...filter} = qs.parse(window.location.search.slice(1), { allowDots: true })
      return {
        query: window.location.search,
        page: Number(page || defaultPage),
        order: order,
        filter
      }
    }
    return {page: 1, filter: {}}
  }

  handleOrderChange = (order) => {
    this.updateUrlState({...this.urlState, order, page: 1})
  }

  handleFilterChange = (filter) => {
    this.updateUrlState({...this.urlState, filter, page: 1})
  }

  handlePageChange = (page) => {
    this.updateUrlState({...this.urlState, page})
  }

  render = () => {
    const {order, page, filter, query} = this.urlState
    return (
      <IndexContext.Provider value={{
        order, page, filter,
        onOrderChange: this.handleOrderChange,
        onFilterChange: this.handleFilterChange,
        onPageChange: this.handlePageChange}}
      >
        <Type
          {...this.props}
          query={query}
          order={order}
          page={page}
          filter={filter}
          onOrderChange={this.handleOrderChange}
          onFilterChange={this.handleFilterChange}
          onPageChange={this.handlePageChange}
        />
      </IndexContext.Provider>
    )
  }
})

const defaultPage = 1